var _rect, _g, _rect2, _rect3, _path, _path2, _path3, _g2, _rect4, _rect5, _rect6, _circle, _rect7, _circle2, _path4, _path5, _g3, _rect8, _path6, _path7, _path8, _path9, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect29, _rect30, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 795,
    viewBox: "0 0 515 795",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.236328,
    y: 438.018,
    width: 105.213,
    height: 7.3427,
    rx: 3.67135,
    fill: "#FFC147"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_599_120940)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.2207,
    y: 184.83,
    width: 121.76,
    height: 126.97,
    rx: 15.7029,
    fill: "#FF0000",
    fillOpacity: 0.01
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.0957,
    y: 172.073,
    width: 144.01,
    height: 150.173,
    rx: 15.7029,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8398,
    y: 190.406,
    width: 47.8966,
    height: 6.2969,
    rx: 3.14845,
    fill: "#D9DBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.284 290.604C114.306 289.058 109.726 286.44 105.868 282.934C102.009 279.429 98.9655 275.121 96.9503 270.313C94.9351 265.505 93.9974 260.314 94.2031 255.105C94.4089 249.896 95.753 244.795 98.1412 240.161",
    stroke: "#FFC147",
    strokeWidth: 22.0186,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4926 243.862C99.4527 236.052 105.057 229.527 112.332 225.423C119.606 221.319 128.088 219.896 136.304 221.4C144.519 222.905 151.947 227.243 157.294 233.658C162.641 240.074 165.57 248.162 165.57 256.514",
    stroke: "#1B6600",
    strokeWidth: 22.0186,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.57 256.514C165.57 262.934 163.838 269.235 160.558 274.753C157.278 280.272 152.57 284.804 146.93 287.872C141.291 290.939 134.928 292.429 128.513 292.185C122.098 291.94 115.867 289.97 110.478 286.482",
    stroke: "#04C017",
    strokeWidth: 22.0186,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_599_120940)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.941,
    y: 424.989,
    width: 169.188,
    height: 128.262,
    rx: 17.3137,
    fill: "#FF0000",
    fillOpacity: 0.01
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 171.344,
    y: 413.923,
    width: 199.553,
    height: 151.282,
    rx: 17.3137,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 189.424,
    y: 433.79,
    width: 52.8099,
    height: 6.94285,
    rx: 3.47143,
    fill: "#D9DBE9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 211.365,
    y: 537.238,
    width: 52.8099,
    height: 6.94285,
    rx: 3.47143,
    fill: "#D9DBE9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 202.107,
    cy: 540.71,
    r: 4.62857,
    fill: "#FA951D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 291.947,
    y: 537.238,
    width: 52.8099,
    height: 6.94285,
    rx: 3.47143,
    fill: "#D9DBE9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.689,
    cy: 540.71,
    r: 4.62857,
    fill: "#1B6600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.316 507.237C221.588 507.237 220.547 493.637 210.604 493.637C200.661 493.637 192.431 511.15 189.424 517.567H352.812V445.361C347.331 457.488 340.256 474.054 331.235 474.054C321.8 474.054 319.88 463.652 308.328 463.652C295.608 463.652 295.577 489.171 284.648 489.171C273.72 489.171 272.78 479.96 261.93 479.96C247.539 479.96 245.611 507.237 232.316 507.237Z",
    fill: "url(#paint0_linear_599_120940)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.426 517.032C192.417 510.662 200.603 493.279 210.493 493.279C220.384 493.279 221.419 506.778 232.091 506.778C245.316 506.778 247.233 479.704 261.548 479.704C272.34 479.704 273.275 488.846 284.146 488.846C295.017 488.846 295.048 463.516 307.7 463.516C319.192 463.516 321.101 473.841 330.486 473.841C339.459 473.841 346.496 457.398 351.949 445.361",
    stroke: "#1B6600",
    strokeWidth: 3.03467,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_599_120940)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.451,
    y: 128.269,
    width: 203.075,
    height: 232.821,
    rx: 17.0922,
    fill: "#FF0000",
    fillOpacity: 0.01
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 222.113,
    y: 101.4,
    width: 241.75,
    height: 277.161,
    rx: 17.0922,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.113 136.493H463.864",
    stroke: "#EFF0F7",
    strokeWidth: 1.48204,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M245.982 122.874C247.935 122.874 249.519 121.29 249.519 119.337C249.519 117.384 247.935 115.8 245.982 115.8C244.029 115.8 242.445 117.384 242.445 119.337C242.445 121.29 244.029 122.874 245.982 122.874Z",
    fill: "#04C017",
    stroke: "#04C017",
    strokeWidth: 1.43666,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.056 122.874C263.01 122.874 264.593 121.29 264.593 119.337C264.593 117.384 263.01 115.8 261.056 115.8C259.103 115.8 257.52 117.384 257.52 119.337C257.52 121.29 259.103 122.874 261.056 122.874Z",
    fill: "#FFC147",
    stroke: "#FFC147",
    strokeWidth: 1.43666,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.131 122.874C278.084 122.874 279.667 121.29 279.667 119.337C279.667 117.384 278.084 115.8 276.131 115.8C274.177 115.8 272.594 117.384 272.594 119.337C272.594 121.29 274.177 122.874 276.131 122.874Z",
    fill: "#55BC00",
    stroke: "#55BC00",
    strokeWidth: 1.43666,
    strokeMiterlimit: 10
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 260.109,
    y: 282.339,
    width: 7.39031,
    height: 45.6383,
    rx: 3.69516,
    fill: "#04C017"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 291.785,
    y: 264.938,
    width: 7.39031,
    height: 38.0261,
    rx: 3.69516,
    fill: "#04C017"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 291.785,
    y: 214.021,
    width: 7.39031,
    height: 45.6383,
    rx: 3.69516,
    fill: "#1B6600"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 291.785,
    y: 308.243,
    width: 7.39031,
    height: 19.7344,
    rx: 3.69516,
    fill: "#1B6600"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 355.129,
    y: 267.706,
    width: 7.39031,
    height: 34.7638,
    rx: 3.69516,
    fill: "#04C017"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 355.129,
    y: 247.232,
    width: 7.39031,
    height: 15.1956,
    rx: 3.69516,
    fill: "#1B6600"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 355.129,
    y: 307.749,
    width: 7.39031,
    height: 20.2289,
    rx: 3.69516,
    fill: "#FA951D"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 323.457,
    y: 279.379,
    width: 7.39031,
    height: 48.5986,
    rx: 3.69516,
    fill: "#1B6600"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 323.439,
    y: 259.035,
    width: 7.39031,
    height: 15.0655,
    rx: 3.69516,
    fill: "#04C017"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 323.439,
    y: 184.83,
    width: 7.39031,
    height: 68.926,
    rx: 3.69516,
    fill: "#FA951D"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 386.801,
    y: 216.228,
    width: 7.39031,
    height: 37.3969,
    rx: 3.69516,
    fill: "#FA951D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 386.801,
    y: 190.72,
    width: 7.39031,
    height: 20.2289,
    rx: 3.69516,
    fill: "#1B6600"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 386.801,
    y: 258.904,
    width: 7.39031,
    height: 69.0742,
    rx: 3.69516,
    fill: "#1B6600"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 418.471,
    y: 249.958,
    width: 7.39031,
    height: 35.4417,
    rx: 3.69516,
    fill: "#1B6600"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 418.473,
    y: 199.041,
    width: 7.39031,
    height: 45.6383,
    rx: 3.69516,
    fill: "#04C017"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 418.471,
    y: 290.679,
    width: 7.39031,
    height: 37.2988,
    rx: 3.69516,
    fill: "#FA951D"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 255.096,
    y: 338.693,
    width: 18.0783,
    height: 5.46042,
    rx: 2.73021,
    fill: "#D9DBE9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 286.639,
    y: 338.693,
    width: 18.0783,
    height: 5.46042,
    rx: 2.73021,
    fill: "#D9DBE9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 318.178,
    y: 338.693,
    width: 18.0783,
    height: 5.46042,
    rx: 2.73021,
    fill: "#D9DBE9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 349.717,
    y: 338.693,
    width: 18.0783,
    height: 5.46042,
    rx: 2.73021,
    fill: "#D9DBE9"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 381.258,
    y: 338.693,
    width: 18.0783,
    height: 5.46042,
    rx: 2.73021,
    fill: "#D9DBE9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 412.797,
    y: 338.693,
    width: 18.0783,
    height: 5.46042,
    rx: 2.73021,
    fill: "#D9DBE9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M183.874 785.627V768.881L153.884 768.687L153.625 793.732L155.489 793.862C163.773 794.397 197.637 795.483 203.149 793.716C209.357 791.803 183.874 785.627 183.874 785.627Z",
    fill: "#1B6600"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M270.955 286.209L271.231 281.135C271.725 278.326 271.936 275.475 271.863 272.624C271.859 271.208 271.607 269.803 271.117 268.474C270.581 266.79 269.817 265.187 268.848 263.708C268.605 263.465 268.447 263.15 268.395 262.81C268.344 262.47 268.401 262.122 268.56 261.818C268.719 261.513 268.971 261.266 269.279 261.113C269.587 260.961 269.936 260.91 270.274 260.969C271.701 261.342 274.619 264.73 275.948 269.787C277.277 274.845 280.682 267.356 281.962 264.649C283.243 261.942 287.652 253.755 288.787 253.496C290.408 253.107 291.202 254.841 289.841 257.516C288.479 260.191 284.977 268.491 286.469 269.107C287.526 268.826 288.632 268.776 289.711 268.961C289.881 268.998 290.035 269.087 290.154 269.214C290.273 269.341 290.35 269.502 290.375 269.674C290.439 270.468 290.597 271.252 290.846 272.008C290.846 272.008 292.856 271.36 293.358 272.219C293.731 273.112 293.955 274.059 294.023 275.024C294.023 275.024 295.547 274.359 296.357 274.878C298.092 276.012 296.211 278.395 296.211 278.395C292.078 284.346 287.567 290.026 282.708 295.4L270.923 285.917",
    fill: "#FCD0CA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.759 285.868L126.564 350.533L154.236 351.813L155.03 336.089C155.03 336.089 164.886 338.051 167.432 328.892C169.053 323.056 168.647 277.877 168.647 277.877L126.759 285.868Z",
    fill: "#FCD0CA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.207 267.891C158.761 270.614 156.734 271.538 152.941 271.83C149.148 272.122 123.47 272.154 121.12 286.63C120.803 285.95 120.559 285.238 120.39 284.507C120.201 283.088 120.098 281.659 120.082 280.227C119.675 280.89 119.419 281.635 119.332 282.408C119.245 283.181 119.33 283.964 119.58 284.701C119.645 285.017 119.737 285.326 119.855 285.625C119.677 285.463 119.515 285.285 119.32 285.123C118.388 284.298 117.279 283.699 116.078 283.372C115.154 283.145 114.554 283.194 114.457 283.372C115.967 284.023 117.397 284.844 118.72 285.82C119.58 286.566 120.318 287.441 120.909 288.413C120.909 288.413 120.909 288.543 120.909 288.608C120.909 288.673 115.381 286.176 116.84 296.195C118.299 306.213 124.832 314.723 125.642 331.129C125.642 331.129 148.548 333.852 152.633 325.05L156.054 314.95C156.054 314.95 150.542 314.043 151.19 309.617C152.082 303.473 156.767 303.327 160.268 306.051L164.289 295.287C164.289 295.287 174.469 288.608 175.052 284.345C175.636 280.081 175.571 265.151 167.207 267.891Z",
    fill: "#0B0A33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0234 773.112L45.9707 791.203L73.9665 794.672L74.9716 776.743L50.0234 773.112Z",
    fill: "#1B6600"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5518 488.761L39.6777 780.034L84.0625 782.547C84.0625 782.547 131.203 531.476 138.125 530.86C141.027 530.585 142.194 780.504 144.512 780.034C146.83 779.564 192.479 780.845 192.479 780.845C192.479 780.845 186.303 485.065 186.417 485.065L91.5518 488.761Z",
    fill: "#3E395F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.123 524.733C157.123 524.959 149.472 526.791 139.94 528.818C130.408 530.844 122.627 532.303 122.578 532.06C122.53 531.817 130.23 530.001 139.762 527.975C149.294 525.948 157.075 524.506 157.123 524.733Z",
    fill: "#7A7D9C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3525 765.445C87.3525 765.688 77.3181 765.558 64.9494 765.185C52.5807 764.812 42.5625 764.294 42.5625 764.067C42.5625 763.84 52.5969 763.953 64.9656 764.326C77.3344 764.699 87.3525 765.185 87.3525 765.445Z",
    fill: "#7A7D9C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.188 765.477C192.188 765.704 181.344 765.574 168.002 765.169C154.661 764.764 143.832 764.261 143.832 764.034C143.832 763.807 154.661 763.937 168.018 764.326C181.376 764.715 192.188 765.185 192.188 765.477Z",
    fill: "#7A7D9C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.712 532.805C113.939 532.805 102.964 584.809 89.185 648.841C75.406 712.873 64.0585 764.764 63.8316 764.715C63.6046 764.666 74.5792 712.727 88.3583 648.663C102.137 584.598 113.469 532.757 113.712 532.805Z",
    fill: "#7A7D9C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.195 764.748C168.176 764.548 168.176 764.347 168.195 764.148C168.195 763.71 168.195 763.126 168.098 762.381C168.098 760.76 167.936 758.506 167.806 755.588C167.563 749.704 167.287 741.161 166.979 730.608C166.363 709.534 165.747 680.355 165.601 648.16C165.455 615.966 165.763 586.803 166.185 565.697C166.379 555.144 166.59 546.617 166.785 540.716C166.882 537.798 166.947 535.529 167.012 533.924C167.012 533.178 167.012 532.595 167.012 532.157C166.99 531.958 166.99 531.757 167.012 531.557C167.037 531.756 167.037 531.958 167.012 532.157V533.924C167.012 535.545 167.012 537.798 167.012 540.716C166.93 546.666 166.817 555.192 166.671 565.713C166.412 586.787 166.185 615.966 166.347 648.16C166.509 680.355 167.012 709.502 167.465 730.608C167.709 741.112 167.903 749.639 168.049 755.588C168.049 758.49 168.146 760.776 168.179 762.381C168.179 763.126 168.179 763.71 168.179 764.148C168.21 764.346 168.215 764.548 168.195 764.748Z",
    fill: "#7A7D9C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M266.302 284.75C266.302 284.75 231.935 336.624 229.017 339.493C226.099 342.363 172.28 348.069 172.28 348.069C155.745 344.34 102.314 345.572 92.2314 352.932C83.4939 357.795 72.8921 369.143 67.4291 395.939C58.108 441.783 48.7869 458.674 67.4291 465.077C74.8823 467.619 82.5642 469.432 90.3672 470.492L89.8485 491.241L186.464 485.227L181.601 433.71C181.017 419.234 180.742 404.158 180.385 390.8C186.432 388.514 242.618 367.246 246.476 366.695C250.334 366.144 287.343 298.075 287.343 298.075C288.445 289.986 266.302 284.75 266.302 284.75Z",
    fill: "#1B6600"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0265 378.561C93.2534 378.561 92.7347 403.817 91.8755 434.942C91.0164 466.066 90.1086 491.306 89.8654 491.306C89.6223 491.306 90.1572 466.05 91.0326 434.925C91.908 403.801 92.7995 378.561 93.0265 378.561Z",
    fill: "#FBFF2B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M233.866 351.165C232.577 349.462 231.62 347.532 231.045 345.475C230.218 343.538 229.545 341.537 229.035 339.493C230.315 341.199 231.266 343.129 231.84 345.183C232.656 347.126 233.334 349.125 233.866 351.165Z",
    fill: "#FBFF2B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M237.724 346.756C236.084 345.832 234.542 344.746 233.12 343.514C231.506 342.484 230.116 341.139 229.035 339.558C230.669 340.49 232.211 341.576 233.639 342.8C235.244 343.841 236.632 345.185 237.724 346.756Z",
    fill: "#FBFF2B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M285.412 302.209C284.27 301.662 283.184 301.005 282.169 300.247C280.192 298.999 277.452 297.313 274.307 295.627C271.162 293.941 268.244 292.596 266.105 291.656C264.909 291.228 263.758 290.685 262.668 290.035C263.928 290.242 265.158 290.601 266.332 291.104C272.1 293.255 277.552 296.172 282.542 299.777C283.597 300.464 284.561 301.281 285.412 302.209Z",
    fill: "#FBFF2B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8754 435.185C89.8622 435.305 87.8428 435.103 85.8936 434.585C83.8868 434.308 81.9506 433.654 80.1875 432.656C82.1779 432.847 84.1472 433.216 86.072 433.758C88.0545 434.011 90.0016 434.49 91.8754 435.185Z",
    fill: "#FBFF2B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M186.483 485.292C186.483 485.535 164.874 487.059 138.207 488.712C111.541 490.366 89.8834 491.533 89.8672 491.306C89.851 491.079 111.476 489.539 138.159 487.869C164.841 486.2 186.467 485.065 186.483 485.292Z",
    fill: "#0B0A33"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.692 346.091C150.011 346.554 145.307 346.733 140.605 346.626C135.907 346.802 131.203 346.699 126.518 346.318C131.198 345.855 135.902 345.676 140.605 345.783C145.302 345.607 150.006 345.71 154.692 346.091Z",
    fill: "#FBFF2B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M127.707 153.152C130.078 153.61 131.931 151.131 130.821 148.987L118.987 126.14C117.894 124.029 114.86 124.069 113.823 126.209L111.692 130.605L99.7137 120.575C98.4813 119.543 96.6435 119.716 95.6249 120.959L91.7744 125.659C90.7336 126.93 90.9602 128.811 92.2729 129.799L105.148 139.48L101.034 143.32C99.3086 144.93 100.139 147.819 102.457 148.267L127.707 153.152Z",
    fill: "#04C017"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M484.013 48.582H419.338C408.292 48.582 399.338 57.5364 399.338 68.5821L399.338 133.257C399.338 144.303 408.292 153.257 419.338 153.257H484.013C495.059 153.257 504.013 144.303 504.013 133.257V68.582C504.013 57.5363 495.059 48.582 484.013 48.582Z",
    fill: "#FFC147"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M476.759 124.71C476.525 126.685 474.875 128.155 472.946 128.155C470.966 128.155 469.317 126.685 469.133 124.71V109.642C468.949 108.167 469.634 106.794 470.879 106.013C472.165 105.232 473.727 105.232 474.963 106.013C476.208 106.794 476.892 108.167 476.759 109.642V124.71Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M455.623 124.709C455.439 126.684 453.79 128.154 451.81 128.154C449.88 128.154 448.231 126.684 447.997 124.709V77.8984C447.864 76.4743 448.548 75.0456 449.793 74.2693C451.029 73.4884 452.591 73.4884 453.881 74.2693C455.122 75.0456 455.806 76.4743 455.623 77.8984V124.709Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M434.215 124.709C434.031 126.685 432.382 128.155 430.402 128.155C428.427 128.155 426.773 126.685 426.594 124.709V92.9666C426.456 91.5379 427.14 90.1185 428.385 89.3375C429.621 88.5566 431.187 88.5566 432.428 89.3375C433.663 90.1185 434.357 91.5379 434.215 92.9666V124.709Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M373.425 514.43H332.199C321.154 514.43 312.199 523.384 312.199 534.429L312.199 575.654C312.199 586.7 321.154 595.654 332.199 595.654H373.425C384.47 595.654 393.425 586.7 393.425 575.654V534.43C393.425 523.384 384.47 514.43 373.425 514.43Z",
    fill: "#04C017"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M348.526 540.094C348.644 540.334 348.722 540.592 348.757 540.857L349.403 550.459L349.723 555.286C349.726 555.782 349.804 556.275 349.954 556.749C350.341 557.669 351.273 558.253 352.286 558.213L367.728 557.203C368.397 557.192 369.042 557.442 369.523 557.898C369.924 558.278 370.182 558.775 370.264 559.31L370.291 559.635C369.652 568.483 363.153 575.863 354.324 577.768C345.494 579.674 336.439 575.649 332.076 567.88C330.818 565.623 330.032 563.142 329.765 560.583C329.653 559.826 329.604 559.06 329.618 558.295C329.604 548.809 336.359 540.607 345.815 538.63C346.954 538.453 348.069 539.056 348.526 540.094Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M354.829 531.849C365.406 532.118 374.295 539.723 376.006 549.968L375.99 550.043L375.943 550.153L375.949 550.455C375.925 550.855 375.771 551.239 375.505 551.55C375.228 551.874 374.849 552.094 374.432 552.179L374.178 552.214L356.362 553.369C355.77 553.427 355.18 553.236 354.739 552.843C354.372 552.515 354.137 552.073 354.071 551.597L352.875 533.807C352.854 533.747 352.854 533.682 352.875 533.621C352.891 533.131 353.107 532.668 353.474 532.334C353.841 532.001 354.329 531.826 354.829 531.849Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M240.239 0.496704H228.169C224.996 0.496704 222.424 3.06912 222.424 6.24236V17.5777C222.424 20.7509 224.996 23.3233 228.169 23.3233H240.239C243.412 23.3233 245.985 20.7509 245.985 17.5777V6.24236C245.985 3.06912 243.412 0.496704 240.239 0.496704Z",
    fill: "#FA951D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M437.849 420.279H420.878C416.416 420.279 412.799 423.896 412.799 428.358V444.297C412.799 448.758 416.416 452.375 420.878 452.375H437.849C442.311 452.375 445.928 448.758 445.928 444.297V428.358C445.928 423.896 442.311 420.279 437.849 420.279Z",
    fill: "#04C017"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5694 332.708H34.5985C30.1366 332.708 26.5195 336.325 26.5195 340.787V356.726C26.5195 361.187 30.1366 364.805 34.5985 364.805H51.5694C56.0313 364.805 59.6484 361.187 59.6484 356.726V340.787C59.6484 336.325 56.0313 332.708 51.5694 332.708Z",
    fill: "#FA951D"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 393.426,
    y: 481.464,
    width: 121.204,
    height: 11.014,
    rx: 5.50702,
    fill: "#1B6600"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1465,
    y: 70.6516,
    width: 128.841,
    height: 7.3427,
    rx: 3.67135,
    fill: "#FFC147"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_599_120940",
    x: 41.2207,
    y: 158.83,
    width: 177.76,
    height: 182.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_120940"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_599_120940",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_599_120940",
    x: 114.941,
    y: 366.989,
    width: 311.188,
    height: 270.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.106615 0 0 0 0 0.121085 0 0 0 0 0.468385 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_120940"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_599_120940",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_599_120940",
    x: 190.451,
    y: 79.4841,
    width: 305.074,
    height: 334.821,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.21503
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0694769 0 0 0 0 0.0656945 0 0 0 0 0.292639 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_120940"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_599_120940",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_599_120940",
    x1: 247.869,
    y1: 470.507,
    x2: 265.974,
    y2: 536.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7481F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647758,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.23ca3a70a6982e0f9fcea9d74acab0aa.svg";
export { ForwardRef as ReactComponent };